import ThanksReminderModal from './ThanksReminderModal';

export default ThanksReminderModal;
